import { createStore } from "jotai";
import { currentWorkspaceAtom } from "./atoms";
import { orderToAssignAtom } from "./atoms/orderToAssign";

export const store: ReturnType<typeof createStore> = createStore();

store.sub(currentWorkspaceAtom, () => {
  store.set(orderToAssignAtom, undefined);
});
